import api from 'common/api'
import { useCallback, useState } from 'react'

export default function useUpdateHighSchoolExplorerPreference() {
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)

  const mutate = useCallback(async ({ enabled }: { enabled: boolean }) => {
    setIsLoading(true)
    setIsSuccess(false)
    setIsError(false)

    try {
      await api.post<boolean, never>('/api/user_ui_preference/use-high-school-explorer', enabled)
      setIsSuccess(true)
    } catch {
      setIsError(true)
    } finally {
      // Reset state after mutation completes
      setIsLoading(false)
      setIsSuccess(false)
    }
  }, [])

  return { isLoading, isSuccess, isError, mutate }
}
